import { useState } from "react";
import { FaLeftLong, FaPlus } from "react-icons/fa6";
const questions = [
  {
    id: 1,
    question: "چه افرادی می‌توانند از خدمات کلینیک لانجویتی استفاده کنند؟",
    answer:
      "مهم‌ترین نکته در انتخاب کلینیک ما این است که برای سلامت خودتان «اهمیت» قائل بوده و «تصمیم جدی» برای اصلاح سبک زندگی‌تان داشته باشید. همانطور که گفتیم لانجویتی فقط شامل خوردن دارو و مکمل نیست و در کنار آن باید دیگر ابعاد زندگی خودتان (مانند ورزش، تغذیه و خواب) را هم اصلاح کنید. ما برای هر یک از آنها به شما برنامه شخصی‌سازی شده می‌دهیم. ",
    showAnswer: false,
  },
  {
    id: 2,
    question: "از چه سنی می‌توانم از خدمات کلینیک لانجویتی استفاده کنم؟",
    answer:
      "افراد بالای ۱۸ سال می‌توانند از خدمات ما استفاده کنند. به این موضوع توجه کنید که توجه به لانجویتی در سنین جوانی نوعی سرمایه‌گذاری برای آينده است و به ده‌های آینده زندگی خودتان کمک بزرگی می‌کنید. هرچند هیچ وقت برای توجه به لانجویتی دیر نیست و شروع مشاوره در دوران سالمندی هم کمک زیادی به ارتقای کیفیت زندگی و سلامت شما خواهد کرد. ",
    showAnswer: false,
  },
  {
    id: 3,
    question: "آیا شما بیماری‌های من را درمان می‌کنید؟",
    answer:
      "تمرکز لانجویتی روی ارتقای قابل توجه سلامت، توانایی‌های فیزیکی و پیشگیری از بروز بیماری‌ها است. در کنار آن تیم ما برخی بیماری‌های مزمن مهم (مانند دیابت، فشارخون بالا و چربی خون) را هم مدیریت خواهند کرد. ",
    showAnswer: false,
  },
  {
    id: 4,
    question: "آیا برای دریافت خدمات لانجویتی باید ساکن تهران باشم؟",
    answer:
      "خیر! شما از هر نقطه از جهان می‌توانید از خدمات کلینیک لانجویتی استفاده کنید. مشاوره‌های پزشکی به صورت آنلاین انجام می‌شوند و برای انجام آزمایش‌ها هم می‌توانید به آزمایشگاه‌های محل زندگی خودتان مراجعه کنید. ",
  },
  {
    id: 5,
    question: "آیا تمام آزمایش‌ها و تست‌های گفته شده را باید انجام دهم؟",
    answer:
      "بسته به محل زندگی شما ممکن است برخی از آزمایش‌های پیشنهادی در دسترس شما نباشد یا با توجه به هزینه‌شان ممکن است نخواهید برخی از آنها را انجام دهید. انجام برخی از تست‌ها اهمیت زیادی دارد و موارد با اولویت بالا معمولا همه‌ جا در دسترس‌اند. اما انجام برخی دیگر به صورت اختیاری خواهد بود.",
  },
  {
    id: 6,
    question: "برنامه دریافتی من شامل چه مواردی است؟",
    answer:
      "در پزشکی کلاسیک تمرکز اصلی روی استفاده از داروها است. اما در موضوع لانجویتی ما به ابعاد مختلف سلامت شما توجه می‌کنیم. برنامه دریافتی شما اینها است:*- اصلاح سبک تغذیه.*- مکمل‌های مورد نیاز (شخصی‌سازی شده برای شما).*- داروهای مورد نیاز (جهت ارتقای سلامت یا کنترل بیماری‌های فعلی).*- پیشنهادات ورزشی شخصی‌سازی شده (قابل ارائه به مربی ورزشی جهت تهیه برنامه ورزشی).*- راهنماهای اصلاح خواب و ارتقای کیفیت آن.",
  },
  {
    id: 7,
    question: " آیا در برنامه لانجویتی طول عمر بیشتری خواهیم داشت؟",
    answer:
      "بله! اگر راهکارهای گفته‌شده توسط متخصصین کلینیک را به خوبی اجرا کنید، می‌توانید انتظار داشته باشید که عمر شما افزایش پیدا کند. ضمنا هرچقدر که توصیه‌ها را بیشتر و دقیق‌تر اجرا کنید، سال‌های عمر شما افزایش بیشتر پیدا می‌کنند. البته همانطور که گفته شد، هدف اصلی ما در کلینیک لانجویتی این است که «کیفیت زندگی» شما و در واقع عمر مفید افزایش پیدا کند.",
  },
  {
    id: 8,
    question: "با شرکت در این برنامه چه چیزی را تضمین می کنید؟",
    answer:
      "لطفا توجه کنید که شما به خاطر درمان یک بیماری خاص به ما مراجعه نکرده‌اید. مثلا در صورت ابتلا به سرماخوردگی با تجویز دارو حال شما بهتر می‌شود و شما خیلی زود اثر آن را مشاهده می‌کنید. اما در موضوع لانجویتی، با یک هدف بلند مواجهیم: ارتقای سلامت، کیفیت زندگی و طول عمر. با اجرای پروتکل‌های کلینیک لانجویتی به‌تدریج توانایی‌های جسمانی و ذهنی شما افزایش پیدا می‌کند. در زندگی شاداب‌تر خواهید بود، بهره‌وری بیشتری خواهید داشت و می‌توانید اطمینان حاصل کنید که همیشه در بهترین وضعیت خودتان هستید.",
  },
  {
    id: 9,
    question: "آیا تصور نمی کنید برنامه‌های لانجویتی هدر دادن سرمایه است؟",
    answer:
      "همه می‌دانیم که داشتن «سلامتی» مهم‌تر از تمام انواع دیگر دارایی‌هاست. پروتکل‌های لانجویتی بهترین و علمی‌ترین روش‌های در دسترس بشر برای حفظ و ارتقای سلامتی هستند. بنابراین شرکت در برنامه‌های لانجویتی به این مفهوم است که شما نسبت به دیگران برای آینده و سلامتی خودتان ارزش بیشتری قائل هستید و این یکی از بهترین سرمایه‌گذاری‌هایی است که می‌توانید برای خودتان انجام دهید.",
  },
  {
    id: 10,
    question: "چرا شرکت در برنامه‌های لانجویتی گران قیمت است؟",
    answer:
      "در کلینیک لانجویتی یک تیم تخصصی تلاش می‌کند تمام ابعاد سلامت شما را پوشش دهد و آن را ارتقا دهد. بعد از مشاوره‌های انجام شده برای انتخاب بهترین راهکارها توسط تیم جلساتی برگزار می‌شود. در کنار آن انجام انواع آزمایش‌ها و تصویربرداری‌ها سبب می‌شود که اطلاعات کامل و جامعی از سلامت شما به‌دست آید. هر کدام از این خدمات دارای هزینه مخصوص به خود است. ما در کلینیک لانجویتی تلاش می‌کنیم هزینه‌ها را تا حد ممکن پایین نگه داریم. اما به طور کلی ورود به برنامه‌ لانجویتی با فرایند‌های ویزیت پزشک کاملا متفاوت است.",
  },
  {
    id: 11,
    question: " آیا برنامه های لانجویتی تحت پوشش بیمه هستند؟",
    answer:
      "برخی از آزمایشات و کارهای پاراکلینیکی مرتبط با لانجویتی تحت پوشش بیمه قرار می‌گیرند. اما مشاوره‌ها و بسیاری از تصویربرداری‌ها و آزمایشات توسط بیمه پوشش داده نمی‌شوند.",
  },
];
const FrequentlyAsked = () => {
  const [questionList, setQuestionlist] = useState(questions);
  const [showAnswers, setShowAbswers] = useState(true);
  const changeShowAnswer = (id) => {
    const newList = questionList.map((item) => {
      if (item.id === id) {
        item.showAnswer = !item.showAnswer;
      }
      return item;
    });
    setQuestionlist(newList);
  };
  const showAllAnswers = () => {
    setShowAbswers((pre) => !pre);
    const newList = questionList.map((item) => {
      showAnswers ? (item.showAnswer = true) : (item.showAnswer = false);
      return item;
    });
    setQuestionlist(newList);
  };
  return (
    <section className=" bg-white  py-6">
      <div className="container mx-auto text-center p-6 max-w-5xl flex gap-8 max-md:flex-col">
        <div className="flex flex-col items-start gap-4 text-right">
          <h2 className=" font-bold text-lg">پرسش های رایج </h2>
          <p>هر آنچه نیاز است در مورد کلینیک لانجویتی بدانید.</p>
          <button className=" flex items-center  gap-2 rounded-lg border-2 px-4 py-2 border-gray-400 text-nowrap w-36 block">
            <span onClick={showAllAnswers} className=" mx-auto">
              {!showAnswers ? "بستن همه" : "باز کردن همه"}
            </span>
            <FaLeftLong className="max-md:-rotate-90" />
          </button>
        </div>
        <div>
          <ul className=" flex flex-col gap-2">
            {questionList.map((question, index) => (
              <li
                key={question.id}
                onClick={() => changeShowAnswer(question.id)}
                className="flex flex-col justify-between bg-slate-50 rounded-lg px-4"
              >
                <div className=" flex justify-between items-center py-4 cursor-pointer">
                  <h3 className=" text-right font-bold ">
                    {question.question}
                  </h3>
                  <FaPlus
                    className={`transition ease-out 0.3s ${
                      question.showAnswer && "rotate-45 "
                    }`}
                  />
                </div>
                {question.answer.split("*").map((line, index) => (
                  <div
                    className={` transition-max-height duration-500 ease-out overflow-hidden ${
                      question.showAnswer ? "max-h-56" : "max-h-0"
                    }`}
                  >
                    <p className="text-right text-gray-600 pb-4">{line}</p>
                  </div>
                ))}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default FrequentlyAsked;
